module.exports = __webpack_public_path__ + "img/009.fe0de40d.svg";